import { empty, trim, strcasecmp, array_column, implode } from '../../php-compat';
import type { PortEnv, PhpRef } from '../../port-contract';
import { isArray, slot, values, type Arr } from './access';
import { findLayerSourceItemId, type LayerSourceDeps } from './resolve_adv_dis_layer_sources';
export interface MarkedTargetDeps extends LayerSourceDeps {
    encounter_creature_field(row: Arr, field: string): unknown;
    creature_statuses(row: Arr, side: string): Arr;
    layer_value(row: Arr, field: string): unknown;
    resolve_adv_dis_layer_sources(row: Arr, field: string): Arr;
    adv_dis_trace_push(roll: PhpRef<Arr>, delta: number, source: string, label: string, status: null,
        item: string | null, kind: string, origin: string | null, originItem: unknown): void;
}
/** PHP: {closure@39:20} (includes/functions/janus/encounter/marked_target_adv.php:39) */
export function closure39MarkScalar(value: unknown): string {
    if (isArray(value)) value = slot(value, 0) ?? '';
    return typeof value === 'string' ? trim(value) : '';
}
/** PHP: ft_creature_is_marked_by (includes/functions/janus/encounter/marked_target_adv.php:37) */
export function ftCreatureIsMarkedBy(opponent: Arr, roller: Arr, env: PortEnv<MarkedTargetDeps>): boolean {
    const id = closure39MarkScalar(slot(roller, 'encounter_creatures', 'encounter_creature_id') ?? env.deps.encounter_creature_field(roller, 'encounter_creature_id'));
    if (id === '') return false;
    for (const row of values(env.deps.creature_statuses(opponent, 'target'))) {
        if (!isArray(row)) continue;
        const status = closure39MarkScalar(slot(row, 'status_item_id') ?? env.deps.item_field(row, 'item_id') ?? '');
        if (status === '' || strcasecmp(status, 'C8163F62-7B18-8221-A60D-C9DD775682E3') !== 0) continue;
        if (strcasecmp(closure39MarkScalar(slot(row, 'status_caster_id') ?? ''), id) === 0) return true;
    }
    return false;
}
/** PHP: ft_apply_marked_target_adv (includes/functions/janus/encounter/marked_target_adv.php:81) */
export function ftApplyMarkedTargetAdv(roll: PhpRef<Arr>, roller: Arr, opponent: Arr, env: PortEnv<MarkedTargetDeps>): null {
    if (empty(env.deps.layer_value(roller, 'adv_vs_own_marked_target')) || !ftCreatureIsMarkedBy(opponent, roller, env)) return null;
    const id = findLayerSourceItemId(roller, 'adv_vs_own_marked_target', env);
    const sources = env.deps.resolve_adv_dis_layer_sources(roller, 'adv_vs_own_marked_target');
    const origin = !empty(sources) ? implode(', ', array_column(sources, 'name')) : null;
    env.deps.adv_dis_trace_push(roll, 1, 'adv_vs_own_marked_target', 'Marked Quarry', null, id, 'passive_ability', origin, slot(sources, 0, 'item_id') ?? id);
    return null;
}
